export default __webpack_public_path__ + "static/media/shaking-hands.dfe92977.png";